import React from 'react';

import { DefaultNotFoundPage } from './DefaultNotFoundPage';

export const SqNotFoundPage: React.FC = () => <DefaultNotFoundPage />;
